import { useContext } from "react";
import { AuthContext } from "../../context/authContext/authContext";
import { AbrirPruebas } from "../../helpers/controlSidebarCheckPruebas";
import { abrirNuevaSalida } from "../../helpers/controlSidebarDerecha";
import { AbrirDetalle } from "../../helpers/controlSidebarDetalle";
import { AbrirEnRuta } from "../../helpers/controlSidebarEnRuta";
import { AbrirRegresos } from "../../helpers/controlSidebarRegresos";
import { scrollToTop } from "../../helpers/scroll";

export const useGeneral = () => {
  const { user } = useContext(AuthContext);
  const openSidebar = (idStatus) => {
    scrollToTop();
    switch (idStatus) {
      case 1:
        abrirNuevaSalida();
        break;
      case 2:
        if (user.rol.toLowerCase() === "GUARDIA DE SEGURIDAD".toLowerCase())
          return AbrirDetalle();
        return AbrirPruebas();
      case 3:
        return AbrirEnRuta();
      case 4:
        return AbrirRegresos();
      case 5:
        if (user.rol.toLowerCase() === "GUARDIA DE SEGURIDAD".toLowerCase())
          return AbrirDetalle();
        return AbrirPruebas();
      case 6:
        return AbrirEnRuta();
      case 36:
        return AbrirEnRuta();
      default:
        break;
    }
  };
  return { openSidebar };
};
